module.exports = __webpack_public_path__ + "img/loader-bar-arrow.a5ae9c79.svg";